import * as z from 'zod';

export const campaignTypeQuerySchema = z.enum(['Digital', 'Physical Mailing']);

export const campaignTypeFormSchema = z.object({
  name: campaignTypeQuerySchema,
  value: campaignTypeQuerySchema,
});

export type CampaignTypeSchema = z.infer<typeof campaignTypeQuerySchema>;

const campaignTypes: CampaignTypeSchema[] = ['Digital', 'Physical Mailing'];

export const campaignTypesOptions: { name: CampaignTypeSchema; value: CampaignTypeSchema }[] = [];

for (let i = 0; i < campaignTypes.length; i++) {
  campaignTypesOptions.push({ name: `${campaignTypes[i]}`, value: `${campaignTypes[i]}` });
}

export function campaignTypeQueryToFormConverter(v: CampaignTypeSchema | null) {
  return v
    ? {
        name: v,
        value: v,
      }
    : campaignTypesOptions[0];
}
